// orderMapper.js

const countBy = (arr, key, unknownValue = "Unknown") => {
  if (!Array.isArray(arr)) {
    return [];
  }

  return Array.from(
    arr.reduce((map, item) => {
      const value =
        item && item[key] != null ? item[key] : unknownValue;

      map.set(value, {
        [key]: value,
        count: (map.get(value)?.count || 0) + 1
      });

      return map;
    }, new Map()).values()
  );
}

const deriveOrderFields = (order) => {
  const { orderRows } = order;

  return {
    orderRowCount: orderRows.length,
    orderRowProductSummary: countBy(orderRows, "product"),
    orderRowSourceSummary: null, // TODO
    orderRowTypeSummary: countBy(orderRows, "productType"),
  };
};

const mapAddress = (address) => {
  if (!address) return null;

  return {
    ...address
  };
};

const mapOrder = (order) => {
  const mappedOrder = {
    ...order,
    deliveryAddress: mapAddress(order.deliveryAddress),
    invoiceAddress: mapAddress(order.invoiceAddress),
    ordererAddress: mapAddress(order.ordererAddress),
    orderRows: mapOrderRows(order.orderRows),
  };

  return {
    ...mappedOrder,
    derivedFields: deriveOrderFields(mappedOrder),
  };
};

const mapOrderRow = (row) => ({
  ...row,
  stockInfo: mapStockInfo(row.stockInfo),
});

const mapOrderRows = (rows) => {
  if (!Array.isArray(rows)) return [];

  return rows.map(mapOrderRow);
};

const mapStockInfo = (stockInfo) => {
  if (!stockInfo) return null;

  return {
    ...stockInfo
  };
};

export { countBy, deriveOrderFields };
export default mapOrder;
